module.exports = __webpack_public_path__ + "images/help/icon-twr47-09e723e4ed1e966407f09c67fcb570ae.png";